import { CODE_STRING } from "../lib/constants";

const initialChatMessages = [
  {
    role: "user",
    content: "What attributes does phone type field has?",
    type: "internal",
  },
  {
    role: "assistant",
    content: `
  ${CODE_STRING}
  - is_mandatory
  - is_read_only
  - is_unique
  - unique_options
  ${CODE_STRING}
  `,
    type: "internal",
  },
  {
    role: "user",
    content: `
  What are the default attribute values for phone type field?,
`,
    type: "internal",
  },
  {
    role: "assistant",
    content: `
  ${CODE_STRING}
  is_mandatory: false
  is_read_only: false
  is_unique: false
  unique_options: null
  ${CODE_STRING}
`,
    type: "internal",
  },
];

export default initialChatMessages;
